import { Component, Input} from '@angular/core';

import {
    LossExpenseCategory,
    LossCostSale,
    LossInventoryLosses,
    LossPayroll,
    LossSummary
} from '../../shared';

@Component({
    selector: 'my-loss-index',
    template: require('./loss-index.component.pug')
})

export class LossIndexComponent {
    @Input() lossExpenseCategories: Array<LossExpenseCategory>;
    @Input() totalLossExpenseCategory: number;

    @Input() lossCostSales: Array<LossCostSale>;
    @Input() totalLossCostSale: number;

    @Input() lossInventoryLosses: Array<LossInventoryLosses>;
    @Input() totalLossInventoryLosses: number;

    @Input() lossPayrolls: Array<LossPayroll>;
    @Input() totalLossPayroll: number;

    @Input() lossSummary: LossSummary;

    constructor() { }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/profit-loss/loss/loss-index.component.ts